import request from './request';

export default {
	async getApplications(query) {
		const res = await request.get('/app/applications', query);
		return res;
	},
	async getApplicationById(id) {
		const res = await request.get(`/app/applications/id?id=${id}`);
		return res;
	},
	async createApplication() {
		const res = await request.post('/app/applications');
		return res;
	},
	async updateApplicationById(params, body) {
		const queryString = new URLSearchParams(params).toString();
		const res = await request.patch(`/app/applications/id?${queryString}`, body);
		return res;
	},
	async cancelApplicationTripById(id) {
		const res = await request.patch(`/app/applications/application-trips/id/cancel?id=${id}`);
		return res;
	},
	async getApplicationPreviousBookings() {
		const res = await request.get('/app/applications/previous-bookings');
		return res;
	},
	async cancelAllTrips(id) {
		const res = await request.patch(`/app/applications/id/application-trips/cancel/all?id=${id}`);
		return res;
	}
};
